module.exports = __webpack_public_path__ + "media/images/emblems/Altbueron_LU-4689143ec2bc7664e13096f0bd51b3d6.png";